import Accordion from '@ui/Accordion';
import Checkbox from '@ui/Checkbox';
import CurrencyInput from '@ui/Input/masked/CurrencyInput';
import React from 'react';
interface PriceRangeFilterSectionProps {
  title: string;
  onChange: (min: number | null, max: number | null) => void;
  min: number | null;
  max: number | null;
  pendingMin?: number | null;
  pendingMax?: number | null;
  startOpen?: boolean;
  titleClassName?: string;
}

const PriceRangeFilterSection = ({
  title,
  onChange,
  max,
  min,
  pendingMin,
  pendingMax,
  startOpen = true,
  titleClassName,
}: PriceRangeFilterSectionProps) => {
  const id = React.useId();
  const minId = `${id}-min`;
  const maxId = `${id}-max`;
  const timeoutRef = React.useRef<any>(null);
  const onMinBlur = (e: any) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const val = e.target.value ?? '';
    if (val === '') return;
    const stripped = val.replace(/[,.]/g, '');
    const intValue = e.target.value ? parseInt(stripped) : null;
    const timeout = setTimeout(() => {
      const currentMax =
        document.querySelector<HTMLInputElement>(`#${maxId}`)?.value ?? max;
      onChange(intValue, currentMax ? parseInt(currentMax.toString()) : null);
    }, 500);
    timeoutRef.current = timeout;
  };
  const onMaxBlur = (e: any) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const val = e.target.value ?? '';
    if (val === '') return;
    const stripped = val.replace(/[,.]/g, '');
    const intValue = e.target.value ? parseInt(stripped) : null;
    const timeout = setTimeout(() => {
      const currentMin =
        document.querySelector<HTMLInputElement>(`#${minId}`)?.value ?? min;
      onChange(currentMin ? parseInt(currentMin.toString()) : null, intValue);
    }, 500);
    timeoutRef.current = timeout;
  };

  const handleCheckboxChange = (selected: boolean, range: string) => {
    if (selected) {
      if (range === 'Under $200') {
        onChange(null, 200);
      } else if (range === '$200 - $500') {
        onChange(200, 500);
      } else if (range === 'Over $500') {
        onChange(501, null);
      }
    } else {
      onChange(null, null);
    }
  };

  const displayMin = pendingMin !== undefined ? pendingMin : min;
  const displayMax = pendingMax !== undefined ? pendingMax : max;

  return (
    <div className="border-b border-zinc-300">
      <Accordion
        title={title}
        startOpen={startOpen}
        titleClassName={titleClassName}
      >
        <div className="flex flex-col gap-y-2 px-[0.8rem] pb-[1rem]">
          <Checkbox
            label="Under $200"
            onChange={(selected = false) =>
              handleCheckboxChange(selected, 'Under $200')
            }
            selected={displayMin === null && displayMax === 200}
          />
          <Checkbox
            label="$200 - $500"
            onChange={(selected = false) =>
              handleCheckboxChange(selected, '$200 - $500')
            }
            selected={displayMin === 200 && displayMax === 500}
          />
          <Checkbox
            label="Over $500"
            onChange={(selected = false) =>
              handleCheckboxChange(selected, 'Over $500')
            }
            selected={displayMax !== null && displayMax > 500}
          />
        </div>

        <div className="mb-[1rem] flex w-full items-center gap-[1.5rem] p-[1.2rem] sm:gap-[0.8rem]">
          <div className="flex max-w-lg grow flex-row items-center justify-between rounded-[1rem] bg-[#F1F1F1] px-[0.8rem] py-[0.8rem]">
            <span className="ml-[1.2rem] mr-[0.8rem] text-[1.8rem] font-semibold tracking-tighter text-brand-black sm:text-input">
              USD
            </span>
            <CurrencyInput
              id={minId}
              placeholder={'Min'}
              value={displayMin ?? ''}
              onChange={(e) => onMinBlur(e)}
              onBlur={(e) => onMinBlur(e)}
              className="!text-[1.8rem] sm:!text-input"
            />
          </div>
          <p className="sm:text-md text-[1.8rem]">to</p>
          <div className="flex max-w-lg grow flex-row items-center justify-between rounded-[1rem] bg-[#F1F1F1] px-[0.8rem] py-[0.8rem]">
            <span className="ml-[1.2rem] mr-[0.8rem] text-[1.8rem] font-semibold tracking-tighter text-brand-black sm:text-input">
              USD
            </span>
            <CurrencyInput
              id={maxId}
              placeholder={'Max'}
              value={displayMax ?? ''}
              onChange={(e) => onMaxBlur(e)}
              onBlur={(e) => onMaxBlur(e)}
              className="!text-[1.8rem] sm:!text-input"
            />
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default PriceRangeFilterSection;
